{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Vous avez dépassé la limite de conversation. Le plan Hacker autorise uniquement 500 conversations.",
      "INBOXES": "Vous avez dépassé la limite de boîtes de réception. Le plan Hacker ne prend en charge que le chat en direct sur le site Web. Des boîtes de réception supplémentaires telles que l'email, WhatsApp, etc. nécessitent un plan payant.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Veuillez contacter votre administrateur pour mettre à niveau le plan et continuer à utiliser toutes les fonctionnalités."
    },
    "TITLE": "Paramètres du compte",
    "SUBMIT": "Mettre à jour les paramètres",
    "BACK": "Précédent",
    "DISMISS": "Rejeter",
    "UPDATE": {
      "ERROR": "Impossible de mettre à jour les paramètres, essayez à nouveau !",
      "SUCCESS": "Paramètres du compte mis à jour avec succès"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Supprimer votre compte",
      "NOTE": "Une fois que vous supprimez votre compte, toutes vos données seront supprimées.",
      "BUTTON_TEXT": "Supprimer votre compte",
      "CONFIRM": {
        "TITLE": "Supprimer le compte",
        "MESSAGE": "La suppression de votre compte est irréversible. Entrez votre nom de compte ci-dessous pour confirmer que vous souhaitez le supprimer définitivement.",
        "BUTTON_TEXT": "Supprimer",
        "DISMISS": "Annuler",
        "PLACE_HOLDER": "Veuillez entrer {accountName} pour confirmer"
      },
      "SUCCESS": "Compte marqué pour suppression",
      "FAILURE": "Impossible de supprimer le compte, essayez à nouveau !",
      "SCHEDULED_DELETION": {
        "TITLE": "Compte programmé pour suppression",
        "MESSAGE_MANUAL": "Ce compte est programmé pour suppression le {deletionDate}. Cette demande a été effectuée par un administrateur. Vous pouvez annuler la suppression avant cette date.",
        "MESSAGE_INACTIVITY": "Ce compte est programmé pour suppression le {deletionDate} en raison de l'inactivité du compte. Vous pouvez annuler la suppression avant cette date.",
        "CLEAR_BUTTON": "Annuler la suppression programmée"
      }
    },
    "FORM": {
      "ERROR": "Veuillez corriger les erreurs du formulaire",
      "GENERAL_SECTION": {
        "TITLE": "Paramètres généraux",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID de compte",
        "NOTE": "Cet identifiant est requis si vous construisez une intégration basée sur l'API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Résolution automatique des conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "La durée de résolution automatique doit être comprise entre 10 minutes et 999 jours",
          "API": {
            "SUCCESS": "Paramètres de résolution automatique mis à jour avec succès",
            "ERROR": "Échec de la mise à jour des paramètres de résolution automatique"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "La conversation a été marquée comme résolue par le système en raison de 15 jours d'inactivité",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferences",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Nom du compte",
        "PLACEHOLDER": "Votre nom de compte",
        "ERROR": "Veuillez entrer un nom de compte valide"
      },
      "LANGUAGE": {
        "LABEL": "Langue du site",
        "PLACEHOLDER": "Votre nom de compte",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domaine de courriel entrant",
        "PLACEHOLDER": "Le domaine où vous allez recevoir les courriels",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Courriel d'assistance",
        "PLACEHOLDER": "L'adresse de courriel de support de votre entreprise",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclure les conversations non prises en charge",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Durée d'inactivité avant résolution",
        "HELP": "Durée après laquelle une conversation doit être automatiquement résolue s'il n'y a pas d'activité",
        "PLACEHOLDER": "30",
        "ERROR": "La durée de résolution automatique doit être comprise entre 10 minutes et 999 jours",
        "API": {
          "SUCCESS": "Paramètres de résolution automatique mis à jour avec succès",
          "ERROR": "Échec de la mise à jour des paramètres de résolution automatique"
        },
        "UPDATE_BUTTON": "Mettre à jour",
        "MESSAGE_LABEL": "Message de résolution personnalisé",
        "MESSAGE_PLACEHOLDER": "La conversation a été marquée comme résolue par le système en raison de 15 jours d'inactivité",
        "MESSAGE_HELP": "Ce message est envoyé au client lorsque la conversation est automatiquement résolue par le système en raison d'une inactivité."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "La continuité des conversations avec les courriels est activée pour votre compte.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Vous pouvez maintenant recevoir des courriels dans votre domaine personnalisé."
      }
    },
    "UPDATE_CHATWOOT": "Une mise à jour {latestChatwootVersion} de Chatwoot est disponible. Veuillez mettre à jour votre instance.",
    "LEARN_MORE": "En savoir plus",
    "PAYMENT_PENDING": "Votre paiement est en attente. Merci de mettre à jour vos informations de paiement pour continuer à utiliser Chatwoot",
    "UPGRADE": "Mettez à niveau pour continuer à utiliser Chatwoot",
    "LIMITS_UPGRADE": "Votre compte a dépassé les limites d'utilisation, veuillez mettre à niveau votre plan pour continuer à utiliser Chatwoot",
    "OPEN_BILLING": "Ouvrir la facturation"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Appuyer sur Entrée pour sélectionner",
      "ENTER_TO_REMOVE": "Appuyer sur Entrée pour supprimer",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Sélectionnez un",
      "SELECT": "Sélectionner"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Tout marquer comme terminé",
    "DELETE_TITLE": "Supprimé",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notifications non lues",
      "ALL_NOTIFICATIONS": "Visualiser toutes les notifications",
      "LOADING_UNREAD_MESSAGE": "Chargement des notifications non lues ...",
      "EMPTY_MESSAGE": "Vous n’avez pas de notifications non lues"
    },
    "LIST": {
      "LOADING_MESSAGE": "Chargement des notifications...",
      "404": "Aucune notification",
      "TABLE_HEADER": [
        "Nom",
        "Numéro de téléphone",
        "Conversations",
        "Dernièrement contacté"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nouvelle conversation",
      "conversation_assignment": "Conversation assignée",
      "assigned_conversation_new_message": "Nouveau message",
      "participating_conversation_new_message": "Nouveau message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Hors ligne",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Actualiser"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Rechercher ou aller à",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Général",
      "REPORTS": "Rapports",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Changer de responsable",
      "CHANGE_PRIORITY": "Modifier la priorité",
      "CHANGE_TEAM": "Changer d’équipe",
      "SNOOZE_CONVERSATION": "Clôturer la conversation",
      "ADD_LABEL": "Ajouter une étiquette à la conversation",
      "REMOVE_LABEL": "Supprimer l'étiquette de la conversation",
      "SETTINGS": "Paramètres",
      "AI_ASSIST": "Assistance IA",
      "APPEARANCE": "Apparence",
      "SNOOZE_NOTIFICATION": "Mettre la notification en veille"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Aller au tableau de bord des conversations",
      "GO_TO_CONTACTS_DASHBOARD": "Aller au tableau de bord des contacts",
      "GO_TO_REPORTS_OVERVIEW": "Accéder à la vue d'ensemble des rapports",
      "GO_TO_CONVERSATION_REPORTS": "Accéder aux rapports de conversation",
      "GO_TO_AGENT_REPORTS": "Aller aux rapports d'agent",
      "GO_TO_LABEL_REPORTS": "Aller aux rapports d'étiquette",
      "GO_TO_INBOX_REPORTS": "Accéder aux rapports de la boîte de réception",
      "GO_TO_TEAM_REPORTS": "Aller dans les rapports de l'équipe",
      "GO_TO_SETTINGS_AGENTS": "Aller dans les paramètres de l'agent",
      "GO_TO_SETTINGS_TEAMS": "Aller dans les paramètres de l'équipe",
      "GO_TO_SETTINGS_INBOXES": "Accéder aux paramètres de la boîte de réception",
      "GO_TO_SETTINGS_LABELS": "Allez dans les paramètres d'étiquette",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Accéder aux paramètres de réponse préenregistrée",
      "GO_TO_SETTINGS_APPLICATIONS": "Accéder aux paramètres de l'application",
      "GO_TO_SETTINGS_ACCOUNT": "Accéder aux paramètres du compte",
      "GO_TO_SETTINGS_PROFILE": "Accéder aux paramètres du profil",
      "GO_TO_NOTIFICATIONS": "Accéder aux notifications",
      "ADD_LABELS_TO_CONVERSATION": "Ajouter une étiquette à la conversation",
      "ASSIGN_AN_AGENT": "Affecter un agent",
      "AI_ASSIST": "Assistance IA",
      "ASSIGN_PRIORITY": "Attribuer priorité",
      "ASSIGN_A_TEAM": "Assigner une équipe",
      "MUTE_CONVERSATION": "Désactiver la conversation",
      "UNMUTE_CONVERSATION": "Rétablir la conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Supprimer l'étiquette de la conversation",
      "REOPEN_CONVERSATION": "Reprendre la conversation",
      "RESOLVE_CONVERSATION": "Reprendre la conversation",
      "SEND_TRANSCRIPT": "Envoyer un résumé par email",
      "SNOOZE_CONVERSATION": "Clôturer la conversation",
      "UNTIL_NEXT_REPLY": "Jusqu’à la prochaine réponse",
      "UNTIL_NEXT_WEEK": "Jusqu'à la semaine prochaine",
      "UNTIL_TOMORROW": "Jusqu'à demain",
      "UNTIL_NEXT_MONTH": "Jusqu'au mois prochain",
      "AN_HOUR_FROM_NOW": "D'ici une heure",
      "UNTIL_CUSTOM_TIME": "Personnalisé...",
      "CHANGE_APPEARANCE": "Changer l'apparence",
      "LIGHT_MODE": "Clair",
      "DARK_MODE": "Sombre",
      "SYSTEM_MODE": "Système",
      "SNOOZE_NOTIFICATION": "Mettre la notification en veille"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Chargement de l'application du tableau de bord ..."
  },
  "COMMON": {
    "OR": "Ou",
    "CLICK_HERE": "cliquez ici"
  }
}
